<h1>DE CIFRIS TRENDS IN MODERN CRYPTOGRAPHY<br>INTRODUCTION TO CRYPTOGRAPHY AND ITS APPLICATIONS</h1>
<div class="toptext">
    <p>
        Not only many Italian cryptographers have joined our association "De Componendis Cifris", but also many
        other EU citizens, such as academics, students, professionals.
    </p>
    <p>
        Among the many purposes of the association, there is support for the study and research in cryptography;
        therefore, it also promotes and coordinates educational and dissemination activities. <br>
        With this in mind, every year the association promotes a new course within the "Trends in Modern
        Cryptography Series" (a similar course was held in <a href="https://www.decifris.it/trends24">2024</a>, <a href="https://www.decifris.it/trends23">2023</a> and <a
        href="https://www.decifris.it/trends22">2022</a>).
    </p>
    <p>
        This year we will have a special course in this series, <b>"Introduzione alla crittografia e applicazioni"</b>.<br>
        A course in Italian, suitable also for people without a strong mathematical background.
    </p>

	<div class="image-container">
		<img mat-card-image src="../../../../assets/images/icons/decifris.svg" style="height: 50px;">
		<img mat-card-image src="../../../../assets/images/logos/unitn.png" style="height: 80px;">
	</div>
</div>

<h2>GENERAL INFORMATION</h2>
<div class="text">
    <h3>Organizers and Lecturers</h3>
    <p>
        Andrea Gelpi, Andrea Visconti e Andrea Gangemi.
    </p>

    <h3> Course structure </h3>
    <p>
        The course is divided into ten online lectures, made available to all participants via a Zoom session. The lessons are held in Italian and take place at 2:00 PM in December 2025. The lectures are recorded and available to all participants of the course. The recorded lectures will be open to everyone a few months after the course, that is, in early 2026.
    </p>

    <h3> Course prerequisites </h3>
    <ul style="list-style-type:none; padding-left: 0;">
        <li>
            Basic understanding of Computer Science: what is an algorithm and what is a program).
        </li>
    </ul>

    <h3> Registration and costs </h3>
    <p>
        The course is free of charge, and any De Cifris member can attend. Registration is open until the 2-nd of December 2025. For any further information about the registration, write to <a href="mailto:trends@decifris.it">trends&#64;decifris.it</a>.
    </p>
</div>

<h2>COURSE PROGRAM</h2>
<div class="row">
    <div class="col-md-12" style="margin-right:5% !important">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col" style="width: 5%;"> Date </th>
                    <th scope="col" style="width: 50%;"> Subject </th>
                    <th scope="col" style="width: 5%;"> Time </th>
                    <th scope="col" style="width: 40%;"> Lecturer </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th scope="row"> Dec 03 </th>
                    <td>
                         Introduzione e Crittografia pubblica/privata e simmetrica <br>
                        <a href="https://drive.google.com/file/d/1YOVC7UavD38AkGI2HD7-e4pqw5IRm2Sh/view?usp=drive_link" target="_blank"> Slide </a> - <a
							href="https://www.youtube.com/watch?v=GHMMeRvl7So&list=PLu4yxTVzRRMX_bgevBQ6yin_UJXyHY3J7&index=10">YT video</a>
                        </td>
                    <td> 14:00 </td>
                    <td> Andrea Gelpi </td>
                </tr>
                <tr>
                    <th scope="row"> Dec 04 </th>
                    <td> 
                        Funzioni hash <br>
                        <a href="https://drive.google.com/file/d/1vUP3miay8idaH95ex38eLrFB0Vs6j-Ii/view?usp=drive_link" target="_blank"> Slide </a> - <a
							href="https://www.youtube.com/watch?v=f5aiB8gQW8s&list=PLu4yxTVzRRMX_bgevBQ6yin_UJXyHY3J7&index=1">YT video</a>
                        
                    </td>
                    <td> 14:00 </td>
                    <td> Andrea Visconti <br> (Università degli Studi di Milano)</td>
                </tr>
                <tr>
                    <th scope="row"> Dec 05 </th>
                    <td>
                         Firma digitale <br>
                        <a href="https://drive.google.com/file/d/15kMGWutzLMO_Gne81VI40G6S0eM0fr-I/view?usp=drive_link" target="_blank"> Slide </a> - <a
							href="https://www.youtube.com/watch?v=Pn3ueR_o-Lc&list=PLu4yxTVzRRMX_bgevBQ6yin_UJXyHY3J7&index=2">YT video</a>
                        </td>
                    <td> 14:00 </td>
                    <td> Andrea Gelpi </td>
                </tr>
                <tr>
                    <th scope="row"> Dec 09 </th>
                    <td>
                         Certificati <br>
                        <a href="https://drive.google.com/file/d/1heMRUrJRq7GqXakbIe30hXc1qgfor885/view?usp=drive_link" target="_blank"> Slide </a> - <a
							href="https://www.youtube.com/watch?v=Pn3ueR_o-Lc&list=PLu4yxTVzRRMX_bgevBQ6yin_UJXyHY3J7&index=3">YT video</a>
                        </td>
                    <td> 14:00 </td>
                    <td> Andrea Gelpi </td>
                </tr>
                <tr>
                    <th scope="row"> Dec 10 </th>
                    <td> 
                        PEC <br>
                        <a href="https://drive.google.com/file/d/1ht6S-0WzsAma5DPsyQTLXiQWTijiqYew/view?usp=drive_link" target="_blank"> Slide </a> - <a
							href="https://www.youtube.com/watch?v=Pn3ueR_o-Lc&list=PLu4yxTVzRRMX_bgevBQ6yin_UJXyHY3J7&index=4">YT video</a>
                    </td>
                    <td> 14:00 </td>
                    <td> Andrea Gelpi </td>
                </tr>
                <tr>
                    <th scope="row"> Dec 11 </th>
                    <td> 
                        Blockchain &amp; Bitcoin <br>
                        <a href="https://drive.google.com/file/d/1lSDfE0iSDmfEJd5HN2kgAjtvFIWuuzAG/view?usp=drive_link" target="_blank"> Slide </a> - <a
							href="https://www.youtube.com/watch?v=Pn3ueR_o-Lc&list=PLu4yxTVzRRMX_bgevBQ6yin_UJXyHY3J7&index=5">YT video</a>
                    </td>
                    <td> 14:00 </td>
                    <td> Andrea Gangemi <br> (Politecnico di Torino) </td>
                </tr>
                <tr>
                    <th scope="row"> Dec 15 </th>
                    <td>
                         Cloud - Struttura albero e cifratura metadati <br>
                        <a href="https://drive.google.com/file/d/14Zc_Yioib3JUTir7ST0Lmk0b9ICPhT2M/view?usp=drive_link" target="_blank"> Slide </a> - <a
							href="https://www.youtube.com/watch?v=Pn3ueR_o-Lc&list=PLu4yxTVzRRMX_bgevBQ6yin_UJXyHY3J7&index=6">YT video</a>
                        </td>
                    <td> 14:00 </td>
                    <td> Andrea Gelpi </td>
                </tr>
                <tr>
                    <th scope="row"> Dec 16 </th>
                    <td>
                         Cloud - Schemi di cifratura funzionale per la condivisione <br>
                        <a href="https://drive.google.com/file/d/1xcHnk_KTH8nc9xMTsDhYYRY-e_h3N1p9/view?usp=drive_link" target="_blank"> Slide </a> - <a
							href="https://www.youtube.com/watch?v=Pn3ueR_o-Lc&list=PLu4yxTVzRRMX_bgevBQ6yin_UJXyHY3J7&index=7">YT video</a>
                        </td>
                    <td> 14:00 </td>
                    <td> Andrea Gelpi </td>
                </tr>
                <tr>
                    <th scope="row"> Dec 17 </th>
                    <td>
                         Cloud - Schemi di cifratura funzionale per le ricerche <br>
                        <a href="https://drive.google.com/file/d/13EYLdwFlmTo-nVpa3Ao3l8_eEPTvQUo0/view?usp=drive_link" target="_blank"> Slide </a> - <a
							href="https://www.youtube.com/watch?v=Pn3ueR_o-Lc&list=PLu4yxTVzRRMX_bgevBQ6yin_UJXyHY3J7&index=8">YT video</a>
                        </td>
                    <td> 14:00 </td>
                    <td> Andrea Gelpi </td>
                </tr>
                <tr>
                    <th scope="row"> Dec 18 </th>
                    <td> 
                        Cloud - Schemi omomorfi per le modifiche <br>
                        <a href="https://drive.google.com/file/d/1sZxbCeS6LJg0iR5Ef1RcvKJS64fTI-Z0/view?usp=drive_link" target="_blank"> Slide </a> - <a
							href="https://www.youtube.com/watch?v=Pn3ueR_o-Lc&list=PLu4yxTVzRRMX_bgevBQ6yin_UJXyHY3J7&index=9">YT video</a>
                    </td>
                    <td> 14:00 </td>
                    <td> Andrea Gelpi </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<h2> EXAMINATION </h2>
<div class="text">
    <p>
        The participants who pass an online test <b>in late January 2026</b> will receive a &quot;Course Attendance&quot;
        certificate. The test consists of a written essay with personalized questions to be completed online in
        one hour.
    </p>
</div>

<h2>INFORMATION FOR ENROLLED STUDENTS</h2>
<div class="text">
    <p>
        Please forward any question about the lectures to <a
            href="mailto:trends@decifris.it">trends&#64;decifris.it</a>.
    </p>
</div>